import axios from "axios";
import { formatDateOnly } from '../components/Utils';

const adminCalendarPath = (calendar, weekStart) => {
  const date = weekStart ? formatDateOnly(weekStart): null;
  let paramsPart = '';
  paramsPart = `${paramsPart}&date=${date}`;
  return `/admin/calendars/${calendar.id}.json?${paramsPart}`;
};
export const getAdminCalendar = (calendar, weekStart, onSuccess, onError) => {
  axios
    .get(adminCalendarPath(calendar, weekStart))
    .then(response => {
      onSuccess(response.data);
    })
    .catch(onError);
};

const adminCalendarDesignersPath = (calendar, search) =>
  `/admin/calendars/${calendar.id}/calendar_designers.json?search=${encodeURIComponent(search)}`;


export const getAdminCalendarDesigners = (calendar, search, onSuccess, onError) => {
  axios
    .get(adminCalendarDesignersPath(calendar, search))
    .then(response => {
      onSuccess(response.data);
    })
    .catch(onError);
};

const adminCalendarSearchDesignersPath = (calendar, search) =>
  `/admin/calendars/${calendar.id}/calendar_designers/search_designers.json?search=${encodeURIComponent(search)}`;

export const adminSearchDesigners = (calendar, search, onSuccess, onError) => {
  axios
    .get(adminCalendarSearchDesignersPath(calendar, search))
    .then(response => {
      onSuccess(response.data);
    })
    .catch(onError);
};



// WEBPACK FOOTER //
// ./app/javascript/components/designer_calendars/api/AdminCalendarApi.js